import * as React from 'react';

export const BigTop3Icon = (id: number | string, props?: React.HTMLAttributes<SVGElement>) => (
  // eslint-disable-next-line react/forbid-elements
  <svg {...props} height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id={`top3-grad-${id}`} x1="50.016%" x2="50.016%" y1="100.016%" y2=".016%">
        <stop offset="0%" stopColor="#FF5050" />
        <stop offset="54.2%" stopColor="#FF7B0D" />
        <stop offset="100%" stopColor="#FF8400" />
      </linearGradient>
    </defs>
    <path
      d="M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm10.698 23.256h-6.512v7.442h-8.372v-7.442H9.302c.091-.463-.12-.852 0-.93L19.535 6.512a2.24 2.24 0 0 1 .93 0l10.233 15.814c.12.078-.091.467 0 .93z"
      fill={`url(#top3-grad-${id})`}
      fillRule="nonzero"
    />
  </svg>
);
